import { useEffect } from "react";

import { useUIStore } from "@/store/useUIStore";

import { getThemeOption } from "./themeOptions";

const THEME_CLASSES = ["theme-violet", "theme-dark", "dark"] as const;

export function useThemeEffect(): void {
  const theme = useUIStore((state) => state.theme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove(...THEME_CLASSES);
    root.classList.add(getThemeOption(theme).cssClass);
    if (theme === "dark") {
      root.classList.add("dark");
    }
  }, [theme]);
}
